import { render } from "./limits-cell.vue?vue&type=template&id=3b1df968&ts=true"
import script from "./limits-cell.ts?vue&type=script&lang=ts"
export * from "./limits-cell.ts?vue&type=script&lang=ts"

import "./limits-cell.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__